export default function translate(i18n, propriete) {
  if (propriete === 'montantHt') {
    return i18n.t('addEditAudit.infoGenerale.montantHT');
  }
  if (propriete === 'dateSouhaitee') {
    return i18n.t('addEditAudit.infoGenerale.dateSouhaite');
  }
  if (propriete === 'titre') {
    return i18n.t('addEditAudit.infoGenerale.titre');
  }
  if (propriete === 'typeOtId') {
    return i18n.t('addEditAudit.messages.error.typeIntervention');
  }
  return propriete;
}
